import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export const MENU_ITEMS = [
  {
    routerLink: 'services',
    title: 'Services'
  },
  {
    routerLink: 'work',
    title: 'Work'
  },
  {
    routerLink: 'team',
    title: 'Team'
  },
  {
    routerLink: 'contact',
    title: 'Contact'
  },
];

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit {
  @Output() menuItemClicked = new EventEmitter();
  @Input() showHome = false;
  menuItems = MENU_ITEMS;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/parts/nav-menu/nav-menu.component.ts